import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registercard',
  templateUrl: './registercard.component.html',
  styleUrls: ['./registercard.component.css']
})
export class RegistercardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
